import { Box, FormLabel, Popover } from '@mui/material';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ColorPicker from 'react-best-gradient-color-picker';

const DEFAULT_COLOR = '#000000';

const ColorEntry = ({ name, value, onChange, disabled }) => {
  const [selectedColor, setSelectedColor] = useState(value || DEFAULT_COLOR);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (value) {
      setSelectedColor(value);
    }
  }, [value]);

  const handleColorChange = (newColor) => {
    setSelectedColor(newColor);
    if (onChange) {
      onChange(newColor);
    }
  };

  const isHex = selectedColor.startsWith('#');

  return (
    <Box mt={1}>
      <FormLabel component="legend" sx={{ color: 'black', mb: 1 }}>{name}</FormLabel>
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        mt={1}
        onClick={(event) => {
          if (!disabled) {
            setAnchorEl(event.currentTarget);
          }
        }}
        sx={{
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          padding: '8px 12px',
          boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
          maxWidth: 360,
          cursor: disabled ? 'default' : 'pointer'
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            flexShrink: 0,
            borderRadius: '50%',
            border: '1px solid rgba(0,0,0,0.15)',
            background: selectedColor
          }}
        />
        <Box
          fontSize={14}
          color="#333"
          sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {isHex ? selectedColor.toUpperCase() : selectedColor}
        </Box>
      </Box>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Box p={1.5}>
          <ColorPicker
            value={selectedColor}
            onChange={handleColorChange}
            width={280}
            height={160}
            hideAdvancedSliders
            hideColorGuide
            disableDarkMode
          />
        </Box>
      </Popover>
    </Box>
  );
};

ColorEntry.propTypes = {
  name: PropTypes.any,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default ColorEntry;
